<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane :label="$t('Inventarios')" class="paddingBody">
        <el-row>
          <el-col :span="8">
            <el-form onsubmit="return false;" label-position="left">
              <el-form-item label="Búsqueda avanzada">
                <el-input
                  :placeholder="$t('Búsqueda por nombre del inventario')"
                  prefix-icon="el-icon-search"
                  v-model="search"
                  class="search"
                  size="medium"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <el-form onsubmit="return false;" label-position="left">
              <el-form-item label="Tipo de contrato">
                <el-select
                  class="tipoContrato"
                  size="medium"
                  v-model="contractType"
                  placeholder="Seleccione tipo"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col
            :span="24"
            element-loading-text="Cargando..."
            element-loading-background="rgba(255, 255, 255)"
            v-loading="loading"
          >
            <el-table
              :data="paginar === false ? inventarios : paginarInventarios()"
              class="inventoryTable"
              :max-height="700"
              row-class-name="rowClassTablaPloma"
              cell-class-name="cellClassTablaPloma"
              header-cell-class-name="headerCellClassTablaPloma"
            >
              <el-table-column :label="$t('Area')" prop="area_id" width="250" sortable>
                <template slot-scope="scope">{{ getAreaName(scope.row.area_id) }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('Empresa')"
                v-if="contractType !== 'Propio'"
                prop="empresa_id"
                width="250"
                sortable
              >
                <template slot-scope="scope">{{ getCompanyName(scope.row.empresa_id) }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('Faena')"
                v-if="contractType == 'Propio'"
                width="250"
                sortable
              >
                <template slot-scope="scope">{{ faena }}</template>
              </el-table-column>
              <el-table-column :label="$t('Nombre')" prop="nombre" sortable></el-table-column>
              <el-table-column
                :label="$t('N° Contrato')"
                v-if="contractType == 'contratista'"
                prop="numero_contrato"
                width="130px"
                sortable
              ></el-table-column>
              <el-table-column
                label="Estado Contrato"
                align="center"
                prop="fecha_fin"
                width="160"
                sortable
              >
                <template slot-scope="scope">
                  <span
                    :class="['safety-tag', isActiveContract(scope.row) ? 'green' : 'red']"
                  >{{ isActiveContract(scope.row) ? $t('Vigente') : $t('Vencido') }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado Inventario" align="center" width="230">
                <template slot-scope="scope">
                  <span
                    :class="`safety-tag font_size_22px inventario_estado inventario_estado_${(JSON.stringify(scope.row.inventario) !== 'null') ? scope.row.inventario.status : 'undefined'}`"
                  >{{ inventario_estado[(JSON.stringify(scope.row.inventario) !== 'null') ? scope.row.inventario.status : "undefined"] }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Visualizar')" align="center" width="90">
                <template slot-scope="scope">
                  <img
                    src="@/assets/contract.svg"
                    class="iconBtn"
                    @click="selectContract(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column :label="$t('PDF')" align="center" width="90">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.inventario
                    && scope.row.inventario.status
                    && parseInt(scope.row.inventario.status, 10) === 2"
                    @click="downloadPDF(scope.row.inventario._id)"
                    class="iconBtn"
                    src="@/assets/icons/pdf-file.svg"
                  />
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center>
              <el-pagination
                :current-page="page"
                @prev-click="backPage"
                @next-click="nextPage"
                @current-change="currentPage"
                :page-size="5"
                layout="prev, pager, next"
                :total="totalPage"
              />
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { contractorRoles } from "@/utils/generalObjects.js";
import moment from "moment";
import axios from "axios";
import funPdf from "@/utils/funPdf/funPdf";

const { downloadPDF } = funPdf;

export default {
  data() {
    return {
      options: [
        {
          value: "Contratista",
          label: "Contratista"
        }
      ],
      inventarios: [],
      loading: false,
      contractorRoles,
      contractType: "Contratista",
      faena: "",
      selectedContract: "",
      isLoadingPDF: false,
      inventario_estado: {
        "undefined": "No iniciado",
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente"
      },
      page: 1,
      totalPage: 0,
      paginar: false,
      search: ""
    };
  },
  computed: {
    ...mapGetters({
      areas: "areas",
      actualRole: "actualRole",
      empresas: "empresas"
    }),
    contracts() {
      return this.$store.getters.userContracts || [];
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log("leaving?");
    next();
  },
  async mounted() {
    if (this.$store.getters.areas.length === 0) {
      await this.getAreasFaena().then(() => {});
    }
  },
  async created() {
    // Título página
    this.setTitle(this.$t("Listado inventarios de riesgos"));
    this.setSubTitle(this.$t("Inventario de riesgos HSE online"));
    this.listadoInventarios(1, this.search);
    if (this.$store.getters.empresas.length === 0) this.getEmpresasFaena();
    this.faena = this.$store.getters.faenasRoles.find(
      f => f._id === this.$store.getters.role.faena_id
    ).nombre;
    if (
      this.$store.getters.role.admin === true ||
      ![
        "contractor_coordinator",
        "contractor_hse",
        "administrator",
        "contract_owner"
      ].includes(this.$store.getters.role.role)
    ) {
      this.options.push({
        value: "Propio",
        label: "Propio"
      });
    }
  },
  watch: {
    contractType: function() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    },
    search: function() {
      this.loading = true;
      this.debounceInputSearch();
    }
  },
  methods: {
    ...mapActions([
      "setTitle",
      "setSubTitle",
      "getAreasFaena",
      "getEmpresasFaena"
    ]),
    debounceInputSearch: _.debounce(function() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    }, 1200),
    paginarInventarios() {
      return this.inventarios.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    getAreaName(id) {
      if (this.areas.length > 0) {
        const area = this.areas.find(a => a._id === id);
        if (area) {
          return area.nombre;
        }
      }
      return id;
    },
    getCompanyName(id) {
      if (this.empresas.length > 0) {
        const empresa = this.empresas.find(e => e._id === id);
        if (empresa) {
          return empresa.nombre;
        }
      }
      return id;
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") {
        return true;
      }
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    listadoInventarios(page, search) {
      this.loading = true;
      var self = this;
      let url = `/contratos/byUFAER?userId=${this.$store.getters.user._id}&faenaId=${this.$store.getters.role.faena_id}`;
      url = this.$store.getters.role.admin
        ? `${url}&role=admin`
        : this.$store.getters.role.area_id === "GeneralAreasRoles"
        ? `${url}&role=allAreas`
        : `${url}&role=${this.$store.getters.role.role}`;
      url = url + `&actualRole=${this.$store.getters.role.role}`;
      if (this.$store.getters.role.area_id) {
        url = `${url}&areaId=${this.$store.getters.role.area_id}`;
      }
      if (this.$store.getters.role.empresa_id) {
        url = `${url}&empresaId=${this.$store.getters.role.empresa_id}`;
      }
      axios
        .get(
          `${url}&page=${page}&tipo=${this.contractType}&search=${
            search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then(response => {
          console.log(response.data);
          self.inventarios = response.data.contratos.results;
          self.totalPage = response.data.contratos.total;
          self.paginar = response.data.contratos.paginar;
          self.loading = false;
        });
    },
    selectContract(contract) {
      // Redireccionar según el perfil del usuario y
      // estado del inventario.
      const { role } = this.$store.getters;
      let url = `/inventario/${contract._id}/ver`;
      if (this.isActiveContract(contract)) {
        if (
          role.admin ||
          ["coordinator", "contractor_coordinator"].includes(role.role)
        ) {
          console.log("Administrador o coordinador");
          if (contract.inventario && contract.inventario.status) {
            switch (parseInt(contract.inventario.status, 10)) {
              case 1:
              case 4:
                url = `/inventario/${contract._id}/revisar`;
                break;
              case 2:
                url = `/inventario/${contract._id}/ver`;
                break;
              case 0:
              case 3:
              default:
                url = `/inventario/${contract._id}/editar`;
            }
          } else {
            url = `/inventario/${contract._id}/editar`;
          }
        } else if (
          contract.inventario &&
          contract.inventario.status &&
          parseInt(contract.inventario.status, 10) === 1
        ) {
          url = `/inventario/${contract._id}/revisar`;
        } // if
      } // if
      this.$router.push({
        path: url
      });
    },
    downloadPDF(id) {
      this.isLoadingPDF = true;
      return new Promise(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        };
        axios.get("/inventarios/print" + `/${id}`, config).then(response => {
          this.isLoadingPDF = false;
          if (response.status === 200) {
            downloadPDF(response, "inventario.pdf");
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.iconBtn {
  width: 25px;
  cursor: pointer;
}
.inventoryTable {
  margin-top: 20px;
}
.search {
  max-width: 340px;
}
.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  background-color: transparent;
  margin: 10px;
}
.content {
  min-height: 50vh;
}
.inventario_estado_vencido {
  background-color: #b84858;
}
.inventario_estado_undefined {
  background-color: red;
}
.inventario_estado_0 {
  background-color: grey;
}
.inventario_estado_1 {
  background-color: #e4d306;
}
.inventario_estado_2 {
  background-color: #6bc45b;
}
.inventario_estado_3 {
  background-color: orange;
}
.inventario_estado_4 {
  background-color: #e4d306;
}
</style>
